const styleMetaKeys = {
  PRICE_ID: 'price_id',
  PATTERN_ID: 'pattern_id'
}

const optionMetaKeys = {
  COLOR_ID: 'color_id',
  DELIVERY_ID: 'delivery_id',
  ASSORTMENT_ID: 'assortment_id'
}

const negatedFilter = {
  ENDPOINT: '!',
  ID: '-1',
  LABEL: 'Other'
}

export { styleMetaKeys, optionMetaKeys, negatedFilter }
